import type { ConnectivityRepository } from '../connectivity'
import { get, post } from './transport'

const enc = encodeURIComponent
const C = '/api/connectivity'

export function connectivityHttp(): ConnectivityRepository {
  return {
    connectivity: () => get(C),
    takeoverPreview: () => get(`${C}/takeover`),
    takeOver: (seen) => post(`${C}/takeover`, { seen }),
    baseRules: () => get(`${C}/base`),
    saveBaseRules: (policy, note) => post(`${C}/base`, { policy, note }, 'PUT'),
    syncNetwork: () => post(`${C}/sync`, {}),
    releaseTag: (tag) => post(`${C}/base/release`, { tag }),
    addMachine: (input) => post(`${C}/machines`, input),
    retireMachine: (id) => post(`${C}/machines/${enc(id)}/retire`, {}),
    joinKey: (machineId) => post(`${C}/machines/${enc(machineId)}/join-key`, {}),
    createTeam: (name, userIds) => post(`${C}/teams`, { name, userIds }),
    renameTeam: (id, name) => post(`${C}/teams/${enc(id)}/rename`, { name }),
    deleteTeam: (id) => post(`${C}/teams/${enc(id)}/delete`, {}),
    setTeamMember: (teamId, userId, member) => post(`${C}/teams/${enc(teamId)}/members`, { userId, member }),
    createGroup: (name, machineIds) => post(`${C}/groups`, { name, machineIds }),
    renameGroup: (id, name) => post(`${C}/groups/${enc(id)}/rename`, { name }),
    deleteGroup: (id) => post(`${C}/groups/${enc(id)}/delete`, {}),
    setGroupMachines: (groupId, machineIds, member) => post(`${C}/groups/${enc(groupId)}/machines`, { machineIds, member }),
    setRule: (input) => post(`${C}/rules`, input),
    endRule: (ruleId) => post(`${C}/rules/${enc(ruleId)}/end`, {}),
    revokeEverything: (userId) => post(`${C}/people/${enc(userId)}/revoke-all`, {}),
    setVisibility: (userId, choice) => post(`${C}/people/${enc(userId)}/visibility`, { choice }),
    addPersonFromNetwork: (input) => post(`${C}/people`, input),
  }
}
